import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=1337cf9a&scoped=true&"
import script from "./CommentField.vue?vue&type=script&lang=js&"
export * from "./CommentField.vue?vue&type=script&lang=js&"
import style0 from "./CommentField.vue?vue&type=style&index=0&id=1337cf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337cf9a",
  null
  
)

export default component.exports